import React from 'react';
import Box from '@mui/material/Box';
import { UserDefinedFormField } from '@/components/UserDefinedForm/UserDefinedFormField';
import type { CmsEditableField } from '@/services/cms/userDefinedForm/CmsEditableField';
import type { CmsEditableFieldGroupData } from '@/services/cms/userDefinedForm/CmsEditableFieldGroupData';

export interface EditableFieldGroupProps extends CmsEditableFieldGroupData {
    fields?: CmsEditableField[];
}

export function EditableFieldGroup(props: EditableFieldGroupProps) {
    return (
        <Box
            component={props.showFieldSet ? 'fieldset' : 'div'}
            sx={
                props.showFieldSet
                    ? {
                          borderRadius: 'var(--mui-shape-borderRadius)',
                          borderStyle: 'solid',
                          borderWidth: 1,
                          borderColor: 'rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)',
                      }
                    : undefined
            }
        >
            {props.title && props.showTitle && (
                <Box
                    component="legend"
                    sx={{
                        color: 'var(--mui-palette-text-secondary)',
                        fontFamily: 'var(--font-poppins)',
                        fontWeight: '400',
                        fontSize: '1rem',
                        lineHeight: '1.4375em',
                        px: 1,
                        py: 0,
                    }}
                >
                    {props.title}
                </Box>
            )}
            <Box
                sx={
                    props.layout === 'Grid'
                        ? {
                              display: 'grid',
                              gridTemplateColumns: 'repeat(2, 1fr)',
                              rowGap: 1,
                              columnGap: 2,
                          }
                        : {}
                }
            >
                {props.fields?.map((field) => (
                    <UserDefinedFormField field={field} key={field.name} />
                ))}
            </Box>
        </Box>
    );
}
